import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  addApiListFailed,
  addApiListSuccessful,
  deleteApiListFail,
  deleteApiListSuccess,
  getApiListFail,
  getApiListSuccess,
  testApiListFail,
  testApiListSuccess,
  updateApiListFail,
  getLocationShopifyFail,
  getLocationShopifySuccess
} from './actions';
import { apiListTypes } from './actionTypes';
import * as url from '../../helpers/url_helper';
import apiFetch from '../../fetch';
import Swal from 'sweetalert2';

//GET

export const GetApiListHelper = async ({ data }: any) => {
  let textClient = '';
  let textIdentificator = '';
  let textName = '';

  if (data.data) {
    textClient = data.data['Search Client ID'];
    textIdentificator = data.data['Search Identificator'];
    textName = data.data['Search Name'];
  }

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }
  const query = `query {
        Apis(FilterEmpresaID:{userId:${user.id}}
            ,filter:{
                ${textClient ? `clientId: ${textClient}` : ''}
                ${textIdentificator
      ? `,identificator: "${textIdentificator}"`
      : ''
    }
                ${textName ? `,name: "${textName}"` : ''}
            }
            
            ){
          id
          identificator
          name
          host
          username
          password
          wsdl
          company
          clientId
          description
          enabled
          tmpToken
          token
          location
          iSubApis{
            host
            token
            entity_id
            api_id
            id
            location
            tokenAccountId
            tokenApplicationKey
            iEntity{
                name
            }
          }
        }
    }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.Apis;
};

function* getApiListSaga(data: any) {
  try {
    const response: Promise<any> = yield call(GetApiListHelper, data);
    if (response !== null || response !== undefined) {
      yield put(getApiListSuccess(response));
    }
  } catch (error) {
    yield put(getApiListFail(error));
  }
}

// ADD

export const AddApi = async ({ payload: { apiAdd } }: any) => {
  const {
    identificator,
    name,
    host,
    username,
    password,
    wsdl,
    company,
    clientId,
    description,
    enabled,
    tmpToken,
    token,
    location,
  } = apiAdd.data;


  const subApis = apiAdd?.data.subApis ?? '';

  const query = `mutation{
        createApis(Apis: {
            identificator: "${identificator}",
            name: "${name}",
            host: "${host}",
            username: "${username}",
            password: "${password}",
            wsdl: "${wsdl}",
            clientId: ${clientId},
            description: "${description}",
            enabled: ${enabled},
            tmpToken: "${tmpToken}",
            token: "${token}",
            location: "${location}",
            subApis: "${JSON.stringify(subApis).replace(/"/g, "'")}"
        }){
            id
        }
    }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.createApis;
};

function* addApiListSaga(api: any) {
  try {
    const response: Promise<any> = yield call(AddApi, api);
    if (response !== null || response !== undefined) {
      const response2: Promise<any> = yield call(getApiListSaga, {
        data: { data: api.payload.apiAdd.queryString },
      });
      yield put(addApiListSuccessful(response));
    }
  } catch (error) {
    yield put(addApiListFailed(error));
  }
}
// ADD SUBAPI
export const AddSubApi = async ({ payload: { apiAdd } }: any) => {
  const { token, entityId, apiId, host, location, tokenAccountId, tokenApplicationKey } = apiAdd.data;

  const query = `
  mutation{
    createSubApis(SubApis:{
      api_id: ${apiId}
      token:"${token}"
      entity_id:${entityId}
      host:"${host}",
      location: "${location}"
      tokenAccountId: "${tokenAccountId}"
      tokenApplicationKey: "${tokenApplicationKey}"
    }){
      id
    }
  }`;

  console.log(query)
  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.createApis;
};

function* addSubApiSaga(api: any) {
  try {
    const response: Promise<any> = yield call(AddSubApi, api);
    if (response !== null || response !== undefined) {
      const response2: Promise<any> = yield call(getApiListSaga, {
        data: api.payload.apiAdd.adminFilters,
      });
      yield put(addApiListSuccessful(response));
    }
  } catch (error) {
    yield put(addApiListFailed(error));
  }
}

// DELETE

export const deleteApiList = async (id: any) => {
  const query = `mutation{
        deleteApis(Apis:{
          id: ${id}
        }){
          id 
        }
    }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.deleteApis;
};

function* deleteApiListSaga({ payload: { id, data } }: any) {
  try {
    const response: Promise<any> = yield call(deleteApiList, id);
    if (response !== null || response !== undefined) {
      const response2: Promise<any> = yield call(getApiListSaga, {
        data: data,
      });
      yield put(deleteApiListSuccess(response));
    }
  } catch (error) {
    yield put(deleteApiListFail(error));
  }
}

export const deleteSubApi = async (id: any) => {
  const query = `mutation{
        deleteSubApi(SubApis:{
          id: ${id}
        }){
          id 
        }
    }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.deleteApis;
};

function* deleteSubApiSaga({ payload }: any) {
  try {
    const response: Promise<any> = yield call(deleteSubApi, payload.id);
    if (response !== null || response !== undefined) {
      const response2: Promise<any> = yield call(getApiListSaga, {
        data: payload.adminFilters,
      });
      yield put(deleteApiListSuccess(response));
    }
  } catch (error) {
    yield put(deleteApiListFail(error));
  }
}

// UPDATE

function* updateApiList({ payload }: any): any {
  const path = url.API_URL;
  const {
    id,
    identificator,
    name,
    host,
    username,
    password,
    wsdl,
    clientId,
    description,
    enabled,
    tmpToken,
    token,
    location,
  } = payload.api.newObject;
  const query = `mutation{
        updateApis(Apis:{
            id: ${id}
            identificator: "${identificator}",
            name: "${name}",
            host: "${host}",
            username: "${username}",
            password: "${password}",
            wsdl: "${wsdl}",
            clientId: ${clientId},
            description: "${description}",
            enabled: ${enabled},
            tmpToken: "${tmpToken}"
            token: "${token}",
            location: "${location}"
          }){
            id
          }
    }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    const resp: any = yield call(apiFetch, path, opts);
    const response2: Promise<any> = yield call(getApiListSaga, {
      data: payload.api,
    });
    //yield put(getApiListSuccess(response2));
  } catch (error) {
    yield put(updateApiListFail(error));
  }
}

export const UpdateSubApi = async ({ payload: { apiUpdate } }: any) => {
  const { id, token, entityId, apiId, host, location, tokenAccountId, tokenApplicationKey } = apiUpdate.data;

  const query = `
    mutation{
        updateSubApi(SubApis:{
            id:${id}
            api_id: ${apiId}
            token:"${token}"
            entity_id:${entityId}
            host:"${host}" ,
            location: "${location}",
            tokenAccountId: "${tokenAccountId}"
            tokenApplicationKey: "${tokenApplicationKey}"     
          }){
        id
      }
    }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response;
};

function* UpdateSubApiSaga(api: any) {
  try {
    const response: Promise<any> = yield call(UpdateSubApi, api);
    if (response !== null || response !== undefined) {
      const response2: Promise<any> = yield call(getApiListSaga, {
        data: api.payload.apiUpdate.adminFilters,
      });
      yield put(addApiListSuccessful(response));
    }
  } catch (error) {
    yield put(addApiListFailed(error));
  }
}

function* testingApiList(payload: any): any {
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }
  const { host, wsdl, username, password } = payload.payload;

  const query = `query {
        testApiMagaya(Credentials: {
          host: "${host}"
          wsdl:"${wsdl}"
          username:"${username}"
          password: "${password}"
          
        }){
          success
          errorMessage
        }
      }`;

  const path = url.API_URL;
  const opts = {
    authRequired: false,
    body: {
      query,
    },
    method: 'POST',
  };

  Swal.fire({
    title: 'Loading...',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
  const response = yield call(apiFetch, path, opts);
  let errorMessage = '';
  Swal.close();
  const responseBody = response.body.data.testApiMagaya;
  if (responseBody.errorMessage != null && responseBody.errorMessage != '') {
    errorMessage = responseBody.errorMessage;
  } else {
    errorMessage = 'An error has occurred';
  }
  if (responseBody !== null || response !== undefined) {
    if (responseBody.success === 'true') {
      yield put(testApiListSuccess(response));
      Swal.fire({
        icon: 'success',
        title: 'Successful API Connection',
      });
    } else if (responseBody.success === 'false') {
      yield put(testApiListFail(errorMessage));
      Swal.fire({
        icon: 'error',
        title: 'Failed api connection',
        text: `${errorMessage}`,
      });
    }
  }
}

export const GetSubApiLocationShopifyHelper = async ({ payload }: any) => {
  const query = `
    query {
           getLocationShopify( token:"${payload.token}", host:"${payload.host}"){
            Message
            Data{
              id
              name
              country_name
              province
              address1
              active
            }
          }
      }
    `;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.getLocationShopify;
};

function* GetSubApiLocationShopifySaga(payload: any) {
  try {
    const response: Promise<any> = yield call(GetSubApiLocationShopifyHelper, payload);
    if (response !== null || response !== undefined) {
      yield put(getLocationShopifySuccess(response));
    }
  } catch (error) {
    yield put(getLocationShopifyFail(error));
  }
}


function* apiListSaga() {
  //Revisar si usamos el takeEvery o TakeLatest
  yield takeEvery(apiListTypes.GET_API_LIST, getApiListSaga);
  yield takeEvery(apiListTypes.ADD_API_LIST, addApiListSaga);
  yield takeEvery(apiListTypes.ADD_SUB_API, addSubApiSaga);
  yield takeEvery(apiListTypes.UPDATE_SUB_API, UpdateSubApiSaga);
  yield takeEvery(apiListTypes.DELETE_API_LIST, deleteApiListSaga);
  yield takeEvery(apiListTypes.DELETE_SUB_API, deleteSubApiSaga);
  yield takeLatest(apiListTypes.UPDATE_API_LIST, updateApiList);
  yield takeLatest(apiListTypes.TEST_API_LIST, testingApiList);
  yield takeLatest(apiListTypes.GET_LOCATION_SHOPIFY, GetSubApiLocationShopifySaga);
}

export default apiListSaga;
